const TooltipManager = (() => {
  let tooltipEl = null;
  let currentTrigger = null;
  let isTouch = false;

  function createTooltip() {
    const el = document.createElement('div');
    el.id = 'rts-tooltip';
    el.setAttribute('role', 'tooltip');
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    return el;
  }

  function getTooltip() {
    if (!tooltipEl) tooltipEl = createTooltip();
    return tooltipEl;
  }

  function position(trigger) {
    const tooltip = getTooltip();
    const gap = 10;
    const arrowSize = 6;
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    let top = triggerRect.top - tooltipRect.height - gap - arrowSize;
    let left = triggerRect.left + triggerRect.width / 2 - tooltipRect.width / 2;
    let isBottom = false;

    // Flip naar onder als er boven onvoldoende ruimte is
    if (top < 8) {
      top = triggerRect.bottom + gap + arrowSize;
      isBottom = true;
    }

    // Horizontaal binnen viewport houden
    left = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));

    // Pijltje wijst altijd naar het midden van de trigger, ook na horizontale verschuiving
    const triggerCenterX = triggerRect.left + triggerRect.width / 2;
    const arrowLeft = Math.max(10, Math.min(triggerCenterX - left, tooltipRect.width - 10));

    tooltip.style.top = top + 'px';
    tooltip.style.left = left + 'px';
    tooltip.style.setProperty('--tooltip-arrow-left', arrowLeft + 'px');
    tooltip.classList.toggle('is-bottom', isBottom);
  }

  function show(trigger) {
    const text = trigger.getAttribute('data-tooltip');
    if (!text || !text.trim()) return;
    if (trigger.hasAttribute('data-tooltip-position')) return;

    const tooltip = getTooltip();
    tooltip.textContent = text;
    void tooltip.offsetHeight; // force layout so getBoundingClientRect returns real dimensions

    // Positie berekenen vóór is-visible zodat visibility:hidden nog actief is
    // (getBoundingClientRect werkt op visibility:hidden elementen)
    position(trigger);

    tooltip.classList.add('is-visible');
    tooltip.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-describedby', 'rts-tooltip');
    currentTrigger = trigger;
  }

  function hide() {
    if (!tooltipEl) return;
    tooltipEl.classList.remove('is-visible');
    tooltipEl.setAttribute('aria-hidden', 'true');
    if (currentTrigger) {
      currentTrigger.removeAttribute('aria-describedby');
      currentTrigger = null;
    }
  }

  function onMouseOver(e) {
    if (isTouch) return;
    const trigger = e.target.closest('[data-tooltip]');
    if (trigger) show(trigger);
  }

  function onMouseOut(e) {
    if (isTouch) return;
    const trigger = e.target.closest('[data-tooltip]');
    if (!trigger) return;
    if (e.relatedTarget && e.relatedTarget.closest('[data-tooltip]')) return;
    if (!trigger.contains(e.relatedTarget)) hide();
  }

  function onTouchStart(e) {
    isTouch = true;
    const trigger = e.target.closest('[data-tooltip]');
    if (trigger) {
      if (currentTrigger === trigger) {
        hide();
      } else {
        e.preventDefault();
        show(trigger);
      }
      return;
    }
    if (currentTrigger) hide();
  }

  function onKeyDown(e) {
    const focused = document.activeElement;
    const trigger = focused && focused.closest('[data-tooltip]');

    if ((e.key === 'Enter' || e.key === ' ') && trigger) {
      e.preventDefault();
      currentTrigger === trigger ? hide() : show(trigger);
    }

    if (e.key === 'Escape' && currentTrigger) {
      hide();
    }
  }

  function init() {
    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseout', onMouseOut);
    document.addEventListener('touchstart', onTouchStart, { passive: false });
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousemove', () => { isTouch = false; }, { passive: true });
    document.addEventListener('focusout', (e) => {
      if (!currentTrigger) return;
      if (!currentTrigger.contains(e.relatedTarget)) hide();
    });
  }

  return { init };
})();

document.addEventListener('DOMContentLoaded', () => TooltipManager.init());
